import {
    CustomAlarmDefinitionApi,
    NotificationTriggerApi,
    TrackableEventApi,
} from 'modules/settings/pods/settings-operator-custom-notifications/service/operator-custom-notifications.api';
import {
    NotificationThreshold,
    OperatorCustomNotification,
    TrackedTrigger,
} from 'modules/settings/pods/settings-operator-custom-notifications/operator-custom-notification.vm';

const mapTrackedTrigger = (event: TrackableEventApi): TrackedTrigger => ({
    id: event.id,
    displayName: event.displayName,
    deviceTypeId: event.deviceTypeId,
});

const mapThreshold = (trigger: NotificationTriggerApi): NotificationThreshold => ({
    enabled: trigger.enabled,
    ...(trigger.numberOfEvents != null && { numberOfEvents: trigger.numberOfEvents }),
});

export const mapOperatorCustomNotificationFromApi = (
    definition: CustomAlarmDefinitionApi
): OperatorCustomNotification => ({
    id: definition.id,
    name: definition.name,
    trackedTriggers: definition.eventsToTrack.map(mapTrackedTrigger),
    windowDays: definition.trackingTypeConfiguration.windowDays,
    grayNotification: mapThreshold(definition.grayNotification),
    yellowNotification: mapThreshold(definition.yellowNotification),
    redNotification: mapThreshold(definition.redNotification),
    isResettable: definition.isResettable,
    requiresCommentOnReset: definition.requiresCommentOnReset,
    active: definition.active,
});

export const mapOperatorCustomNotificationsFromApi = (
    definitions: CustomAlarmDefinitionApi[]
): OperatorCustomNotification[] => definitions.map(mapOperatorCustomNotificationFromApi);
